import { render, staticRenderFns } from "./StickyHistory.vue?vue&type=template&id=1d857fad&"
import script from "./StickyHistory.vue?vue&type=script&lang=js&"
export * from "./StickyHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports